// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"f15ac20f","377":"af0d1c46","863":"53d59f6f"}[chunkId] + ".chunk.js";
};